import { useEffect, useState } from "react";

const useReducedMotion = () => {
  const [r, setR] = useState(false);
  useEffect(() => {
    const m = window.matchMedia("(prefers-reduced-motion: reduce)");
    setR(m.matches);
    const h = (e) => setR(e.matches);
    m.addEventListener("change", h);
    return () => m.removeEventListener("change", h);
  }, []);
  return r;
};

export function LiveLogo({ className = "" }) {
  const reduced = useReducedMotion();
  const [deg, setDeg] = useState(() => new Date().getSeconds() * 6);
  useEffect(() => {
    if (reduced) return;
    let raf;
    const tick = () => {
      const d = new Date();
      setDeg((d.getSeconds() + d.getMilliseconds() / 1000) * 6);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [reduced]);
  return (
    <div className={`relative select-none ${className}`} data-testid="live-logo">
      <img src="/logo.webp" alt="GoldenTime — Luxury" className="w-full h-auto" draggable={false} />
      <svg viewBox="0 0 100 100" className="absolute pointer-events-none" style={{ left: "37%", top: "28.2%", width: "26%", height: "26%" }} aria-hidden="true">
        <g style={{ transform: `rotate(${deg}deg)`, transformOrigin: "50px 50px" }} data-testid="live-logo-seconds-hand">
          <line x1="50" y1="62" x2="50" y2="6" stroke="#E6D5AC" strokeWidth="0.9" strokeLinecap="round" />
          <circle cx="50" cy="6.5" r="1.3" fill="#E6D5AC" />
        </g>
        <circle cx="50" cy="50" r="2.2" fill="#C8AE6E" stroke="#0C0B09" strokeWidth="0.6" />
      </svg>
    </div>
  );
}
